class PrinciplesSlider extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        const initFn = () => {
            const firstSlide = this.querySelector('.principles-slide');
            const slideWidth = firstSlide ? firstSlide.offsetWidth : 0;

            if (typeof window.Swiper !== 'undefined' && slideWidth > 100) {
                setTimeout(() => {
                    this.initSwiper();
                }, 100);
            } else {
                setTimeout(initFn, 100);
            }
        };
        initFn();
    }

    initSwiper() {
        const container = this.querySelector('.swiper');
        if (!container) return;

        const safari = document.documentElement.classList.contains('safari');

        this.swiper = new Swiper(container, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            observer: !safari,
            observeParents: !safari,
            spaceBetween: 10,
            breakpoints: {
                750: {
                    spaceBetween: 160
                }
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            speed: 1000,
            allowTouchMove: true,
            on: {
                init: function () {
                    // Принудительно заставляем Swiper пересчитать ширину ленты после старта
                    setTimeout(() => {
                        this.update();
                    }, 500);
                }
            }
        });
    }
}

if (!customElements.get('principles-slider')) {
    customElements.define('principles-slider', PrinciplesSlider);
}
